import { LazyLoad } from 'app/utils';

export const DepartmentSortPage = LazyLoad(() => import('./index'), (module) => module.DepartmentSortPage);
